import { ArenaIcon } from '@sorare/core/src/atoms/icons/ArenaIcon';
import { ProModeIcon } from '@sorare/core/src/atoms/icons/ProModeIcon';
import { type Unit } from '@sorare/core/src/lib/style';

import { Mode } from '#src/lib/gameMode.ts';

type Props = {
  mode: Mode;
  size?: Unit;
};

export const ModeIcon = ({ mode, size = 3 }: Props) => {
  if (mode === Mode.PRO) return <ProModeIcon size={size} />;
  return <ArenaIcon size={size} />;
};
